import { CURRENCIES } from '../../config/currencies';

export function formatCurrency(value: number, currency: string): string {
  const config = CURRENCIES[currency];
  if (!config) return value.toString();

  const isNegative = value < 0;
  const absValue = Math.abs(value);
  
  // Format the number with appropriate decimals and separators
  const formattedValue = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: config.decimals,
    maximumFractionDigits: config.decimals,
    useGrouping: true
  }).format(absValue);

  // Add currency symbol in correct position
  const symbol = config.symbol;
  return isNegative 
    ? `-${config.symbolPosition === 'before' ? `${symbol}${formattedValue}` : `${formattedValue}${symbol}`}`
    : config.symbolPosition === 'before' ? `${symbol}${formattedValue}` : `${formattedValue}${symbol}`;
}

export function formatCurrencyCompact(value: number, currency: string): string {
  const config = CURRENCIES[currency];
  if (!config) return value.toString();

  const billion = 1000000000;
  const million = 1000000;
  const thousand = 1000;
  const isNegative = value < 0;
  const absValue = Math.abs(value);

  let formattedValue: string;
  let suffix: string;

  if (absValue >= billion) {
    formattedValue = (absValue / billion).toFixed(2);
    suffix = 'billion';
  } else if (absValue >= million) {
    formattedValue = (absValue / million).toFixed(2);
    suffix = 'million';
  } else if (absValue >= thousand) {
    formattedValue = (absValue / thousand).toFixed(2);
    suffix = 'thousand';
  } else {
    formattedValue = absValue.toFixed(2);
    suffix = '';
  }

  // Remove trailing zeros after decimal point
  formattedValue = formattedValue.replace(/\.?0+$/, '');

  const symbol = config.symbol;
  const formattedNumber = `${formattedValue}${suffix ? ` ${suffix}` : ''}`;
  
  return isNegative
    ? `-${config.symbolPosition === 'before' ? `${symbol}${formattedNumber}` : `${formattedNumber}${symbol}`}`
    : config.symbolPosition === 'before' ? `${symbol}${formattedNumber}` : `${formattedNumber}${symbol}`;
}

export function formatCurrencyNoDecimals(value: number, currency: string): string {
  const config = CURRENCIES[currency];
  if (!config) return value.toString();

  const isNegative = value < 0;
  const absValue = Math.abs(value);
  
  // Format the number without decimals
  const formattedValue = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    useGrouping: true
  }).format(absValue);

  // Add currency symbol in correct position
  const symbol = config.symbol;
  return isNegative 
    ? `-${config.symbolPosition === 'before' ? `${symbol}${formattedValue}` : `${formattedValue}${symbol}`}`
    : config.symbolPosition === 'before' ? `${symbol}${formattedValue}` : `${formattedValue}${symbol}`;
} 